












































































































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-alert */
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ExportActions } from '@/store/dbExports/actions';
import { AccessPayload, ImportProgressDTO } from '@/store/dbExports/types';
import IntegrityProgressBar from './IntegrityProgressBar.vue';

// eslint-disable-next-line no-shadow
const enum SnackBarStates {
  API_ERROR,
  INVALID_INPUT,
  SUCCESS,
  IMPORT_WITH_ERROR,
}

const dbExportModule = namespace('dbExports');

@Component({
  components: {
    IntegrityProgressBar,
  },
})
export default class ImportNassco extends Vue {
  items = ['PACP / MACP Access DB'];

  selectedUploadType = this.items[0];

  @Prop() selectedFile: any;

  snack = false;

  snackColor = 'black';

  snackText = '';

  snackTimeout = 3000;

  snackTextClass = '';

  email = '';

  invalidDatabase = false;

  successfulImport = false;

  isFormValid = false;

  successAlert = false;

  errorAlert = false;

  loadingAlert = false;

  isImportWithErrors = false;

  @Prop() readonly projectGuid: string | undefined;

  @dbExportModule.Action(ExportActions.POST_NASSCO_DB) postNassco;

  @dbExportModule.Action(ExportActions.CONTINUE_NASSCO_DB) continuePostNassco;

  @dbExportModule.Action(ExportActions.CLEAR_IMPORT_DATA) clearImportData;

  @dbExportModule.Action(ExportActions.GET_PROGRESS_IMPORT_UPDATE)
  getProgressImportUpdate;

  @dbExportModule.State('data') exportState: string | undefined;

  @dbExportModule.State('loadError') loadError: string | undefined;

  @dbExportModule.State('importID') importID: string | undefined;

  @dbExportModule.State('loading') loading: boolean;

  @dbExportModule.State('continueLoadingState') continueLoadingState: boolean;

  @dbExportModule.State('continueError') continueError: string | undefined;

  @dbExportModule.State('importProgress') importProgress:
    | ImportProgressDTO
    | undefined;

  @dbExportModule.State('importProgressLoadingState')
  importProgressLoadingState: string | undefined;

  @dbExportModule.State('importProgressError')
  importProgressError: string | undefined;

  menu = false;

  async mounted(): Promise<void> {
    const user = await this.$auth.getUser();
    if (user != null) {
      this.email = user.email;
    }
  }

  async onClickUpload(): Promise<void> {
    this.successfulImport = false;
    this.successAlert = false;
    this.errorAlert = false;
    this.loadingAlert = true;

    // check if we can upload
    if (this.selectedFile && this.selectedFile.length === 0) {
      this.snackBar(SnackBarStates.INVALID_INPUT);
      return;
    }
    // switch items so we upload to right thing
    switch (this.selectedUploadType) {
      case this.items[0]: {
        // post access db
        const formPayload = new FormData();
        formPayload.append('files', this.selectedFile as any);
        formPayload.append('email', this.email);
        formPayload.append(
          'overrideValidationFailure',
          this.invalidDatabase.toString(),
        );
        formPayload.append('fileType', this.selectedUploadType);
        const dbProgressBar = this.$refs.dbProgressBar as any;
        const config = {
          onUploadProgress: (progressEvent) => dbProgressBar.updateProgressBar(
            progressEvent.loaded,
            this.selectedFile.size,
          ),
        };
        const payload: AccessPayload = {
          projectGuid: this.projectGuid,
          payload: formPayload,
          config,
        };
        try {
          await this.postNassco(payload);
          // check if we failed in response object
          if (this.exportState === 'ERROR: Import Failed') {
            this.snackBar(SnackBarStates.API_ERROR, 'ERROR: Import Failed');
            alert('Database import failed.');
            // otherwise we succeeded
          } else {
            this.showSuccessfulImport();
          }
        } catch (e) {
          this.showErrorImport();
        }
        break;
      }
      default:
        alert('Selected upload type not implemented.');
        break;
    }
  }

  showSuccessfulImport(isImportWithErrors = false): void {
    this.successfulImport = true;
    this.successAlert = !isImportWithErrors;
    this.loadingAlert = false;
    this.isImportWithErrors = isImportWithErrors;

    this.getProgressUpdates();
  }

  showErrorImport(): void {
    this.errorAlert = true;
    this.loadingAlert = false;
  }

  snackBar(state: SnackBarStates, errorText = '', timeout = 3000, snackTextClass = ''): void {
    this.snackTimeout = timeout;
    switch (state) {
      case SnackBarStates.INVALID_INPUT:
        this.snackText = errorText === '' ? 'INVALID INPUT' : errorText;
        this.snackColor = 'orange';
        this.snack = true;
        this.snackTextClass = snackTextClass;
        break;
      case SnackBarStates.API_ERROR:
        this.snackText = errorText === '' ? 'API ERROR' : errorText;
        this.snackColor = '#e61e25';
        this.snack = true;
        this.snackTextClass = snackTextClass;
        break;
      case SnackBarStates.SUCCESS:
        this.snackText = errorText;
        this.snackColor = 'green';
        this.snack = true;
        this.snackTextClass = snackTextClass;
        break;
      default:
        this.snackText = errorText;
        this.snackColor = 'black';
        this.snack = true;
        this.snackTextClass = snackTextClass;
    }
  }

  async continueDownload(continueImport: boolean): Promise<void> {
    const payload = {
      importID: this.importID,
      email: this.email,
      ignoreValidation: continueImport,
      projectGuid: this.projectGuid,
      fileType: this.selectedUploadType,
    };
    try {
      await this.continuePostNassco(payload);
    } catch (e) {
      alert(this.continueError);
    }
    if (continueImport && !this.continueError) {
      this.showSuccessfulImport(true);
    }
  }

  async getProgressUpdates(): Promise<void> {
    await this.$nextTick();
    const importingProgressBar = (this.$refs.importingProgressBar as IntegrityProgressBar);
    if (!importingProgressBar?.updateProgressBar) {
      return;
    }
    const { updateProgressBar } = importingProgressBar;
    updateProgressBar(0, this.selectedFile?.size);
    let importingInterval = true;
    while (importingInterval) {
      try {
        // eslint-disable-next-line no-await-in-loop
        await this.getProgressImportUpdate(this.importID);
        if (this.importProgress) {
          updateProgressBar(
            this.importProgress?.importedBytes ?? 0,
            this.importProgress?.totalBytes ?? 0,
          );
        }
      } catch {
        importingInterval = false;
      }
      // eslint-disable-next-line no-await-in-loop
      await new Promise((resolve) => setTimeout(resolve, 1000));
    }
    this.reset();
    if (importingProgressBar?.completeProgressBar) {
      importingProgressBar.completeProgressBar();
    }
  }

  ImportingOnFileUploaded(): void {
    this.snackBar(SnackBarStates.SUCCESS, 'Import Complete!', -1, 'success-snack-text');
  }

  reset(): void {
    this.menu = false;
    this.clearImportData();
  }

  get validInspections(): number {
    const validInspectionsObject = this.exportState['validInspections'];
    return validInspectionsObject.length;
  }

  get invalidInspections(): number {
    return (this.exportState['invalidInspectionIds'] ?? []).length;
  }

  get validationErrors(): number {
    // Find length of nested array(s) of validation errors
    const validationErrorsObject = this.exportState['validationErrors'];
    return this.findAllNestedArraysLength(validationErrorsObject);
  }

  findAllNestedArraysLength(obj: unknown): number {
    if (obj === null) {
      return 0;
    }

    if (typeof obj === 'string') {
      return 1;
    }

    let newLength = 0;

    Object.keys(obj).forEach((key) => {
      const value = obj[key];
      newLength += this.findAllNestedArraysLength(value);
    });

    return newLength;
  }
}
